<template>
    <td class="" v-if="data.html" v-html="data.html" :class="data.class"></td>
    <td class="" v-else-if="data.emit_click" @click="emitAction(data.emit_value)" class="action-cell"><span :uk-icon="data.icon"></span></td>
    <td class="checkbox-data-cell" v-else-if="data.input_type=='checkbox'"><input type="checkbox" v-model="checked" @input="processInput" :key="data.id"></td>
    <td class="text-input-data-cell" v-else-if="data.input_type"><input :type="data.input_type" placeholder="Type Email Here" v-model="data_input" @input="processInput" :key="data.id"></td>
    <td v-else> -- </td>
</template>

<script>
    export default {
        name: "dataCell",
        props: ['data'],
        data: function() {
            return {
                data_input: "",
                checked: false,
            }
        },
        methods: {
            processInput: function(input) {
                // console.log(input)
                let output = {
                  data: this.data_input_processed,
                  id: this.data.id,
                  type: this.data.input_type
                }
                this.$emit('output', output)
            },
            emitAction: function(value) {
                console.log('action', value)
                this.$emit('action', value);
            }
        }, computed: {
            data_input_processed: function() {
                if (this.data.input_type == 'checkbox') {
                    return !this.checked
                } else {
                    return this.data_input
                }

            }
	    }
    }
</script>

<style lang="less" scoped>




    .action-cell {
        cursor: pointer;
    }



</style>
